module.exports = __webpack_public_path__ + "img/stage1.b8546146.png";